import type { PageMeta } from "./en";

export const enVrat: Record<string, PageMeta> = {
  ekadashi: {
    title: "Ekadashi {year} — Dates, Vrat Rules, Paaran Time & Puja Vidhi | Ishvaram",
    description:
      "Ekadashi {year} & {nextyear} dates — full vrat (fasting) rules, paaran timing, Vishnu puja vidhi and upay. Dated by tithi, not a fixed calendar.",
    keywords: [
      "ekadashi",
      "ekadashi {year}",
      "ekadashi vrat",
      "ekadashi dates",
      "ekadashi paaran time",
      "ekadashi fasting rules",
      "nirjala ekadashi",
      "ekadashi vrat vidhi",
    ],
  },
  amavasya: {
    title: "Amavasya {year} — Dates, Pitru Tarpan, Shradh & Puja Vidhi | Ishvaram",
    description:
      "Amavasya {year} & {nextyear} dates — new moon meaning, Pitru Tarpan & Shradh vidhi, Mahalaya & Mauni Amavasya, and upay for Pitra Dosh. Dated by tithi, not a fixed calendar.",
    keywords: [
      "amavasya",
      "amavasya {year}",
      "amavasya date",
      "amavasya tithi",
      "pitru tarpan",
      "shradh amavasya",
      "mahalaya amavasya",
      "mauni amavasya",
      "amavasya puja vidhi",
    ],
  },
  purnima: {
    title: "Purnima {year} — Dates, Satyanarayan Vrat & Puja Vidhi | Ishvaram",
    description:
      "Purnima {year} & {nextyear} dates — full moon meaning, Satyanarayan vrat rules & puja vidhi, Guru, Sharad & Kartik Purnima, plus upay for an unsettled Moon. Dated by tithi, not a fixed calendar.",
    keywords: [
      "purnima",
      "purnima {year}",
      "purnima date",
      "purnima tithi",
      "satyanarayan vrat",
      "sharad purnima",
      "guru purnima",
      "kartik purnima",
      "purnima puja vidhi",
    ],
  },
  pradosh: {
    title: "Pradosh Vrat {year} — Dates, Trayodashi, Shiva Puja Vidhi | Ishvaram",
    description:
      "Pradosh Vrat {year} & {nextyear} dates — Trayodashi meaning, Som, Bhaum & Shani Pradosh, Shiva puja vidhi, and upay for Shani dosha. Dated by tithi, not a fixed calendar.",
    keywords: [
      "pradosh vrat",
      "pradosh vrat {year}",
      "pradosh tithi",
      "shani pradosh",
      "som pradosh",
      "bhaum pradosh",
      "trayodashi vrat",
      "pradosh puja vidhi",
      "pradosh kaal",
    ],
  },
  "sankashti-chaturthi": {
    title: "Sankashti Chaturthi {year} — Dates, Vrat, Moonrise & Ganesh Puja Vidhi | Ishvaram",
    description:
      "Sankashti Chaturthi {year} & {nextyear} dates — Chaturthi vrat & moonrise (Chandra Darshan) rules, Ganesh puja vidhi, Angarki, and upay for blocked work. Dated by tithi, not a fixed calendar.",
    keywords: [
      "sankashti chaturthi",
      "sankashti chaturthi {year}",
      "sankashti chaturthi dates",
      "sankashti vrat",
      "angarki chaturthi",
      "ganesh chaturthi vrat",
      "chandra darshan time",
      "sankashti puja vidhi",
    ],
  },
  "masik-shivratri": {
    title: "Masik Shivratri {year} — Dates, Vrat, Night Vigil & Shiva Puja Vidhi | Ishvaram",
    description:
      "Masik Shivratri {year} & {nextyear} dates — Chaturdashi vrat & night-vigil rules, Shiva puja vidhi & abhishek, how it differs from Maha Shivratri, and Shani/Mangal upay via Shiva. Dated by tithi, not a fixed calendar.",
    keywords: [
      "masik shivratri",
      "masik shivratri {year}",
      "masik shivratri dates",
      "masik shivratri vrat",
      "shivratri vrat vidhi",
      "shiva puja vidhi",
      "maha shivratri",
      "mahamrityunjaya mantra",
    ],
  },
  sankranti: {
    title: "Sankranti {year} — All 12 Sankranti Dates, Makar Sankranti & Puja Vidhi | Ishvaram",
    description:
      "Sankranti {year} & {nextyear} dates for all 12 solar Sankrantis — Makar Sankranti & Uttarayan, snan-daan punya kaal rituals, and what each Sankranti means for you. Dated by the Sun's ingress, not a fixed calendar.",
    keywords: [
      "sankranti",
      "sankranti {year}",
      "sankranti dates",
      "makar sankranti",
      "makar sankranti {year}",
      "uttarayan",
      "surya sankranti",
      "sankranti puja vidhi",
    ],
  },
  "vrat-calendar": {
    title: "Vrat Calendar {year} — Hindu Vrat & Fast Dates, Ekadashi to Sankranti | Ishvaram",
    description:
      "Hindu vrat calendar {year} — Ekadashi, Purnima, Amavasya, Pradosh, Sankashti Chaturthi, Masik Shivratri & Sankranti, each with its next date plus a link to full dates & puja vidhi. Dated by tithi, not a fixed calendar.",
    keywords: [
      "vrat calendar",
      "vrat calendar {year}",
      "hindu vrat calendar",
      "vrat list {year}",
      "fasting calendar",
      "ekadashi pradosh sankashti dates",
      "hindu fast dates",
      "vrat tyohar calendar",
    ],
  },
};
